import {
  DEFAULT_DISTRIBUTION_PARTNER_NUMBER,
  DISTRIBUTION_PARTNER_TYPE,
  DISTRIBUTION_PARTNER_TYPES,
} from '@/config/constants'

function createDistributionPartner(distributionPartnerNumber, distributionPartnerType) {
  return {
    distributionPartnerType,
    distributionPartnerNumber,
  }
}

/**
 * Baskets created in dvp have the same distributionPartnerNumber for all types
 *
 * @param distributionPartnerNumber
 * @returns {{distributionPartnerNumber: *, distributionPartnerType: *}[]}
 */
function createDistributionPartners(distributionPartnerNumber) {
  return DISTRIBUTION_PARTNER_TYPES.map(type => createDistributionPartner(distributionPartnerNumber, type))
}

/**
 * DISTRIBUTION_PARTNER_TYPE.ABSCHLUSS is the default used for e.g. Service center call
 * @param basket
 * @param type
 * @returns {*}
 */
function getDistributionPartnerNumber(distributionPartners, type = DISTRIBUTION_PARTNER_TYPE.ABSCHLUSS) {
  const partner = distributionPartners?.find(p => p.distributionPartnerType === type)
  return partner?.distributionPartnerNumber
}

function isDefaultDistribution(basket) {
  const partnerNr = getDistributionPartnerNumber(basket?.distributionPartners)
  return partnerNr === DEFAULT_DISTRIBUTION_PARTNER_NUMBER
}

// TODO shouldn't this be a computed consuming the basket
function hasDistributionPartner(basket) {
  return !isDefaultDistribution(basket) && !basket.collective
}

export default function useDistribution() {
  return {
    // Methods
    createDistributionPartners,
    getDistributionPartnerNumber,
    hasDistributionPartner,
  }
}
